import { PAYEX_URL } from 'constants/config';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';
import type {
  ApplyCouponPayload,
  CouponAvailabilityPayload,
  CouponAvailabilityResponse,
  CouponOfferResponse,
  RemoveCouponPayload,
} from './model';

export type CouponsService = {
  apply: (payload: ApplyCouponPayload) => Promise<CouponOfferResponse>;
  remove: (payload: RemoveCouponPayload) => Promise<CouponOfferResponse>;
  getAvailability: (
    payload: CouponAvailabilityPayload,
  ) => Promise<CouponAvailabilityResponse>;
};

export const coupons: CouponsService = {
  apply: ({ orderId, token, couponCode }) => {
    const path = `${PAYEX_URL}/coupons/${orderId}`;
    const options = {
      method: 'POST',
      body: JSON.stringify({ token, coupon_code: couponCode }),
    };

    return fetchWithAuthentication(path, options);
  },
  remove: ({ orderId, token }) => {
    const path = `${PAYEX_URL}/coupons/${orderId}?token=${encodeURIComponent(token)}`;

    return fetchWithAuthentication(path, { method: 'DELETE' });
  },
  getAvailability: ({ orderId, token }) => {
    const path = `${PAYEX_URL}/coupons/${orderId}/availability`;
    const options = {
      method: 'POST',
      body: JSON.stringify({ token }),
    };

    return fetchWithAuthentication(path, options);
  },
};
